interface JiraiProgressBarProps {
  current: number;
  total: number;
}

const JiraiProgressBar = ({ current, total }: JiraiProgressBarProps) => {
  const percent = Math.min((current / total) * 100, 100);

  return (
    <div
      className="w-full"
      style={{ height: '3px', background: 'rgba(225,29,72,0.1)' }}
    >
      <div
        style={{
          height: '100%',
          width: `${percent}%`,
          background: 'linear-gradient(90deg, #e11d48 0%, #9f1239 100%)',
          transition: 'width 0.4s ease',
          borderRadius: '0 2px 2px 0',
        }}
      />
    </div>
  );
};

export default JiraiProgressBar;
